import { FC } from "react";
import { Transition } from "@headlessui/react";
import { Skeleton } from "./Skeleton";
import { opacityEnter } from "../../ui/layout/Transition/constants";

const skeletonStyleClassNames = {
  iconStyle: "h-5 w-20 rounded-md",
  rowSmStyle: "h-5 w-1/2 rounded-md",
  rowNormalStyle: "h-6 w-1/2 rounded-md",
};

type SkeletonOptions = {
  amount: number;
  className?: string;
  skeletonStyle?: keyof typeof skeletonStyleClassNames;
};

type AppearedContentProps = {
  isLoaded: boolean;
  skeletonOptions: SkeletonOptions;
};

const renderSkeletons = (skeletonOptions: SkeletonOptions) => {
  const { amount, className, skeletonStyle } = skeletonOptions;
  return (
    <div className={amount > 1 ? "flex w-full gap-1.5" : ""}>
      {[...Array(amount)].map((_, i) => (
        <Skeleton
          className={
            skeletonStyle ? skeletonStyleClassNames[skeletonStyle] : className
          }
          key={i}
        />
      ))}
    </div>
  );
};

export const AppearedContent: FC<
  React.PropsWithChildren<AppearedContentProps>
> = ({ isLoaded, children, skeletonOptions }) => (
  <>
    <Transition
      as="div"
      show={isLoaded}
      enter="transition-opacity duration-700"
      {...opacityEnter}
      className="z-0 empty:hidden"
    >
      {children}
    </Transition>
    {!isLoaded && renderSkeletons(skeletonOptions)}
  </>
);
